import './Map.css';
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker, Tooltip } from 'react-leaflet';


function mapa(){

    const position = [-25.341069, -49.292697];
    const position2 = [-25.338909, -49.290924];
    const position3 = [-25.344416, -49.294220];
    const position4 = [-25.342457, -49.291791];
    const position5 = [-25.342457, -49.289190];
    const position6 = [-25.340962, -49.290228];
    const position7 = [-25.340250, -49.291449];
    const position8 = [-25.342493, -49.287916];
    const position9 = [-25.340570, -49.287785];
    const position10 = [-25.341508, -49.292158];

    return (
        <div className="card-area">
            <div className="map-title">
                <h3>TRACKING</h3>
            </div>
            <div className="map-area">
                <div id="mapid">
                    <MapContainer center={[-25.341567, -49.290687]} zoom={15} scrollWheelZoom={false}>
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                        <CircleMarker
                            center={[-25.341567, -49.290687]}
                            pathOptions={{ color: 'green' }}
                            radius={200}>
                            <Tooltip>TRACKING AREA</Tooltip>
                        </CircleMarker>
                    
                        <Marker position={position}>
                            <Popup>
                                Sensor: Bonfim #Alpha &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.010876, -47.561079 <br />
                                
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position2}>
                            <Popup>
                                Sensor: Bonfim #Beta &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.010569, -47.561524 <br />
                                
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position3}>
                            <Popup>
                                Sensor: Bonfim #Gama &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.034829, -47.580217 <br />
                               
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position4}>
                            <Popup>
                                Sensor: Bonfim #Delta &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.045873, -47.543966 <br />
                       
                                Status: OFF <br />
                                Manutenção: Em andamento<br />
                                Scenario: No data
                            </Popup>
                        </Marker>
                        <Marker position={position5}>
                            <Popup>
                                Sensor: Bonfim #Épsilon &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.067534, -47.561225 <br />
                      
                                Status: Online <br />
                                Scenario: High danger <br />
                            </Popup>
                        </Marker>
                        <Marker position={position6}>
                            <Popup>
                                Sensor: Bonfim # Zeta &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.045873, -47.543966 <br />
                          
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position7}>
                            <Popup>
                                Sensor: Bonfim #Eta &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.045873, -47.543966 <br />
                            
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position8}>
                            <Popup>
                                Sensor: Bonfim #Teta &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.045873, -47.543966 <br />
               
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position9}>
                            <Popup>
                                Sensor: Bonfim #Iota &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.045873, -47.543966 <br />
              
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>
                        <Marker position={position10}>
                            <Popup>
                                Sensor: Bonfim #Capa &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Loc: -14.045873, -47.543966 <br />
                      
                                Status: Online <br />
                                Scenario: Low danger
                            </Popup>
                        </Marker>

                    
                    </MapContainer>
                </div>

            </div>
        </div>
    )
}

export default mapa;